module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_pp3_1.2de26de6.png";